
const mediaQuery = window.matchMedia('(max-width: 749px)')
// Check if the media query is true
if (mediaQuery.matches) {
  const popupButtons = document.querySelectorAll(".popup-buttons");
  const popupCloseBtns = document.querySelectorAll(".popupclose");
  const themeOverlay = document.querySelector(".theme-overlay");
  
  [].forEach.call(popupButtons, (popupButton) => {
    popupButton.addEventListener("click", (e) => {
      e.preventDefault();
      const popupId = popupButton.dataset.popup;
      const themePopup = document.querySelector(popupId)
      themePopup.classList.add("show");
      themeOverlay.classList.add("show");
    })
  });
  
  [].forEach.call(popupCloseBtns, (popupCloseBtn) => {
    popupCloseBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const popupId = popupCloseBtn.closest(".theme-popup").classList.remove("show");
      themeOverlay.classList.remove("show");
    })
  })
}